import { useState } from 'react';
import InputCity from '../components/InputCity';
import citiesJson from '../json/minicipios.json';
import MatchedCitiesList from '../components/MatchedCitiesList';
import LastSearchesList from '../components/LastSearchesList';
import { setLocalStorage, getLocalStorage } from '../helpers/localStorage';
import MapBox from '../components/MapBox';
import './Search.css';

const normalize = (string) => {
    const stringLowerCase = string.toLowerCase().trim();
    const newString = stringLowerCase.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    
    return newString;
}

const Search = ({ sectionChangeHandler, currentCity, setCurrentCity }) => {
    const [cities, setCities] = useState([]);
    const [mapOpen, setMapOpen] = useState (false);
    const [lastSearches, setLastSearches] = useState(getLocalStorage('lastSearches', 'array'));

	// La ciudad es modificada en MatchedCitiesList y LastSearchesList
	const cityChangeHandler = (cityData) => {
		setLocalStorage('currentCity', cityData);
		setCurrentCity(cityData);
		addToLastSearches(cityData);
		sectionChangeHandler('home');
	}

	const addToLastSearches = (cityData) => {
		// Si ya está en la lista saca la ciudad de la lista antes de volver a agregarla
		const previousLastSearches = lastSearches.filter(city => city.name !== cityData.name);
		// Muestra las últimas 10 búsquedas, si hay más, se elimina la más antigua
        while (previousLastSearches.length > 9) previousLastSearches.pop();
		// Por último añade la nueva búsqueda al principio del array
		const newLastSearches = [cityData, ...previousLastSearches];
        setLastSearches(newLastSearches);
		setLocalStorage('lastSearches', newLastSearches);
	}

	const cityRemoveHandler = (e, cityData) => {
		e.stopPropagation();
		const newLastSearches = lastSearches.filter(city => city.name !== cityData.name);
		setLastSearches(newLastSearches);
		setLocalStorage('lastSearches', newLastSearches);
	}

    const onInputChange = (value) => {
        if (value === '') return setCities([]);
        
        const inputValue = normalize(value);
            
        // Devuelve todos los valores del json que coincidan con lo introducido
        const citiesMatch = citiesJson.filter((city) => {
            const cityName = normalize(city.name);
            return cityName.includes(inputValue);
        })

        setCities(citiesMatch);        
    }

    const CancelButton = () => {
        if (currentCity === undefined) {return null}
        return <button className="search__cancel-btn" onClick={() => sectionChangeHandler('home')}>Cancelar</button>
    }

    const changeMapState = () => {
        setMapOpen(!mapOpen)
    }

    const onMapPointSelect = ( selectedPointData ) => {
        cityChangeHandler(selectedPointData);
    }

    return (
        <>
            <header className="search-header">
                <InputCity onInputChange={onInputChange} currentCity={currentCity} />
                <button onClick={changeMapState} className="search__icon-map"><img src="/icons/map-marker.png" alt="search map" /></button> 
                <CancelButton />
            </header>
            <main className="search-main">
                {mapOpen && <MapBox closeMapHandler={changeMapState} selectPointHandler={onMapPointSelect} />}
                {cities.length === 0 
                  ? <LastSearchesList lastSearches={lastSearches} cityChangeHandler={cityChangeHandler} cityRemoveHandler={cityRemoveHandler} /> 
                  : <MatchedCitiesList cities={cities} cityChangeHandler={cityChangeHandler} />
                }
            </main>
        </>
    );
}
  
export default Search;
